export class StoreHandler {
  constructor({ World, Emitter, Tick, Animate, PBRProgram, ogl }) {
    const _this = this;
    const gl = World.gl;

    const ZONE_LIMIT = 10;

    let currentActive = null;

    const DATA = {
      Store1: {
        title: `Limited Coupon`,
        message: `Use this coupon for a discount on a Trippie Hoodie!`,
        prompt: `Check it out`,
        link: `https://shop.trippieredd.com/products/moon-high-school-hoodie`
      },
      Store2: {
        title: `Sweaty?`,
        message: `Get some sweatpants!`,
        prompt: `Hook me up`,
        link: `https://shop.trippieredd.com/collections/bottoms/products/pegasus-leg-sweatpants-black`
      }
    };

    this.match = {
      // materialName: 'StoneShader.001',
      // meshName: 'MeshCube',
      // objectName: 'GroupCube',
      groupName: "store"
    };

    // World.playerPosition

    // Store nodes for when handling events
    const nodes = [];

    {
      Tick.on(update);
    }

    function update() {
      let closest = null;
      let closestDist = Infinity;

      nodes.forEach(async node => {
        const dist = node.position.distance(World.playerPosition.value);
        if (dist > ZONE_LIMIT) return; // Out of zone
        if (dist < closestDist) {
          closestDist = dist;
          closest = node;
        }
      });

      if (!closest && currentActive) {
        // Close popup
        currentActive.traverse(child => {
          if (!child.program) return;
          child.program.uniforms.uStoreActive.value = 0;
        });
        currentActive = null;
        window.TRIGGER_CLOSE_POPUP && window.TRIGGER_CLOSE_POPUP();
      }

      if (closest && !currentActive) {
        // Open popup
        currentActive = closest;
        currentActive.traverse(child => {
          if (!child.program) return;
          child.program.uniforms.uStoreActive.value = 1;
        });
        window.TRIGGER_OPEN_POPUP &&
          window.TRIGGER_OPEN_POPUP(DATA[currentActive.name]);
      }

      if (closest && closest !== currentActive) {
        // Change popup
        currentActive.traverse(child => {
          if (!child.program) return;
          child.program.uniforms.uStoreActive.value = 0;
        });
        currentActive = closest;
        currentActive.traverse(child => {
          if (!child.program) return;
          child.program.uniforms.uStoreActive.value = 1;
        });
        window.TRIGGER_UPDATE_POPUP &&
          window.TRIGGER_UPDATE_POPUP(DATA[currentActive.name]);
      }
    }

    // window.TRIGGER_OPEN_POPUP = ({ title, message, prompt, link }) => {
    //     console.log('OPEN POPUP', title);
    // };

    // window.TRIGGER_UPDATE_POPUP = ({ title, message, prompt, link }) => {
    //     console.log('UPDATE POPUP', title);
    // };

    // window.TRIGGER_CLOSE_POPUP = () => {
    //     console.log('CLOSE POPUP');
    // };

    this.add = group => {
      if (!group.children.length) return;
      group.children.forEach(node => {
        if (!node.name || !DATA[node.name]) return;

        node.traverse(child => {
          if (!child.program) return;
          // Replace program
          const program = PBRProgram.parseGLTF(
            child,
            [
              {
                match: `// UNIFORMS`,
                replacement: `uniform float uStoreActive;`
              },
              {
                match: `// FINAL COLOR`,
                replacement: `color = mix(color, vec3(0.7, 0.7, 1.0), uStoreActive * 0.8);`
              }
            ],
            {
              uStoreActive: { value: 0 }
            }
          );
          child.program = program;
        });

        nodes.push(node);
      });
    };

    this.fallback = () => {
      //
    };

    this.destroy = () => {
      //
    };
  }
}
